<svg class="d-flex" role="img" aria-labelledby="loading-aria11" viewBox="0 0 179 46" preserveAspectRatio="none">
  <title id="loading-aria11">Loading...</title>
  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
  <rect x="0" y="0" width="100%" height="100%" clip-path="url(#clip-path11)" style="fill: url('#fill11')" />
  <defs>
    <clipPath id="clip-path11">
      <svg:circle cy="25" cx="30" r="10" />
      <svg:rect y="20" x="60" rx="3" width="82" height="12" />
    </clipPath>
    <linearGradient id="fill11">
      <stop offset="0.599964" stop-color="#f3f3f3" stop-opacity="1">
        <animate attributeName="offset" values="-2; -2; 1" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
      </stop>
      <stop offset="1.59996" stop-color="#ecebeb" stop-opacity="1">
        <animate attributeName="offset" values="-1; -1; 2" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
      </stop>
      <stop offset="2.59996" stop-color="#f3f3f3" stop-opacity="1">
        <animate attributeName="offset" values="0; 0; 3" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
      </stop>
    </linearGradient>
  </defs>
</svg>
